import 'regenerator-runtime/runtime';

// export const BASE_URL = `https://w1.tpn.pl`;
export const BASE_URL = window.location.href.match(/^http:\/\/localhost:8080/) ?
	`http://localhost:9996/no.php` : `/api.php`;

const X_API_CLIENT = '09b84e30-00e3-440c-9ab5-713327d91b8e';

let OAUTH2_KEY = null;
if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('ttl')) {
	if (parseInt(sessionStorage.getItem('ttl')) > Date.now()) {
		OAUTH2_KEY = sessionStorage.getItem('uuid');
	}
}

let inProgress = [];

const buildUrl = path => {
	let url = path.match(BASE_URL) ? path : `${BASE_URL}${path}`;
	url += (url.match(/\?/) ? '&' : '?') + 'X_API_CLIENT=' + X_API_CLIENT;
	if (OAUTH2_KEY !== null && OAUTH2_KEY !== undefined) {
		url += '&OAUTH2_KEY=' + OAUTH2_KEY;
	}
	return url;
};

const GUARDIAN = {
	observers: {},
	addObserver: async (path, mainCallback, notifier) => {
		console.log('addObserver',
			path,
			mainCallback,
			notifier,
			GUARDIAN.observers[path]
		);
		if (!GUARDIAN.observers[path]) {
			GUARDIAN.observers[path] = {
				mainCallback,
				notify: [notifier]
			};
			const data = await mainCallback();
			GUARDIAN.observers[path].notify.forEach(notifier => notifier(data));
			delete GUARDIAN.observers[path];
		}
		else {
			GUARDIAN.observers[path].notify.push(notifier);
		}
	}
};

const _guardRequest = async (path, method = 'GET', data = {}, headers = {}) => new Promise(async (resolve, reject) => {
	try {
		if (method === 'GET') {
			await GUARDIAN.addObserver(path, () => _request(path, method, data, headers), resolve);
		}
		else {
			resolve(await _request(path, method, data, headers));
		}
	} catch (err) {
		reject(err);
	}
});

const _request = async (path, method = 'GET', data = {}, headers = {}) => {

	if (method === 'POST' && inProgress.indexOf(path) !== -1) {
		console.warn(`Locked ${path}`);
		return false;
	}
	inProgress.push(path);

	const requestData = {
		method,
		headers: {
			X_API_CLIENT,
			OAUTH2_KEY,
			...headers
		},
		mode: 'no-cors'
	};

	let url = buildUrl(path);

	if (method !== 'GET' && method !== 'DELETE') {
		data = data || {};
		const formData = new FormData();
		for (let key in data) {
			const value = data[key];
			if (typeof value === 'object') {
				for (let i in value) {
					formData.append(`${key}[${i}]`, value[i]);
				}
			}
			else {
				formData.append(key, value);
			}
		}
		requestData.body = formData;
	}

	const req = () => new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		// xhr.withCredentials = true;
		// for (let i in requestData.headers) {
		// 	xhr.setRequestHeader(i, requestData.headers[i]);
		// }
		xhr.open(method, url);
		xhr.onload = function () {
			if (this.status >= 200 && this.status < 300) {
				const response = JSON.parse(xhr.response);
				resolve(response);
			}
			else {
				if (this.status === 401) {
					window.location.href = '/logout';
				}
				const response = {
					...(JSON.parse(xhr.response)),
					status: this.status
				};
				reject(response);
			}
		};
		xhr.onerror = function () {
			const response = {
				...(JSON.parse(xhr.response)),
				status: this.status
			};
			if (this.status === 401) {
				window.location.href = '/logout';
			}
			reject(response);
		};
		xhr.send(requestData.body || null);
	});

	try {
		const result = await req();
		inProgress = inProgress.filter(item => item !== path);
		return result;
	} catch (err) {
		inProgress = inProgress.filter(item => item !== path);
		throw err;
	}
};

export const request = _request;

export const authRequest = async (path, method = 'GET', data = {}, headers = {}) => {
	if (!OAUTH2_KEY) {
		return;
	}
	return await _request(path, method, data, headers);
};

const _guardAuthRequest = async (path, method = 'GET', data = {}, headers = {}) => {
	if (!OAUTH2_KEY) {
		return;
	}
	return await _guardRequest(path, method, data, headers);
}

export const login = async (login, password) => {
	try {
		const resp = await request('/auth/login', 'POST', {
			login,
			password
		});
		if (resp.uuid) {
			OAUTH2_KEY = resp.uuid;
		}
		return resp;
	} catch (err) {
		throw err;
	}
};

export const logout = async () => {
	try {
		const resp = await request('/auth/logout', 'POST');
		OAUTH2_KEY = null;
		return resp;
	} catch (err) {
		throw err;
	}
};


export const getAgree = async () => await authRequest('/meals/api-agree/get');

export const setAgree = async () => await authRequest('/meals/api-agree/post', 'POST', { agree: 1 });

export const adminGetConfig = async () => await authRequest('/meals/api-admin-config/get');

export const adminSetConfig = async (data) => await authRequest('/meals/api-admin-config/post', 'POST', data);

export const getEntryFilters = async () => await _guardAuthRequest(`/meals/api-entry/get-filters`, 'GET');

// export const getEntries = (filters = {}) => new Promise(async (resolve, reject) => {
// 	const query = Object.keys(filters)
// 		.map(k => encodeURIComponent(`filters[${k}]`) + '=' + encodeURIComponent(filters[k]))
// 		.join('&');
// 	const path = `/meals/api-entry/get-list?${query}`;
// 	try {
// 		await GUARDIAN.addObserver(path, () => authRequest(path, 'GET'), resolve);
// 	} catch (err) {
// 		reject(err);
// 	}
// });

export const getEntries = async (filters = {}) => {
	const query = Object.keys(filters)
		.map(k => encodeURIComponent(`filter[${k}]`) + '=' + encodeURIComponent(filters[k]))
		.join('&');
	const path = `/meals/api-entry/get-list?${query}`;
	return await _guardAuthRequest(path, 'GET');
};

export const addEntry = async (entry) => await authRequest('/meals/api-entry/post', 'POST', entry);

export const putEntry = async (entry) => await request(`/meals/api-entry/post-update/id/${entry.nr_rek}`, 'POST', entry);

export const putEntries = async (entries) => await request(`/meals/api-entry/post-mass-update`, 'POST', { entries });

export const deleteEntry = async (entry) => await request(`/meals/api-entry/post-delete/id/${entry.nr_rek}`, 'POST', entry);

export const adminGetUsers = async () => await authRequest('/meals/api-admin-user/get-list', 'GET');

export const adminSetCard = async (user) => await authRequest('/meals/api-admin-user/post', 'POST', user);

export const getReportUrl = obj => buildUrl('/meals/api-entry/get-report') + '&' + Object.keys(obj).map(k => `${k}=${obj[k]}`).join('&');



// WEBPACK FOOTER //
// ./api.js